import Link from '@components/common/Link'
import useInput from '@hooks/useInput'
import { createNewQueryClient, jsonFetcher, ResponseError, UnprocessableEntity } from '@lib/fetcher'
import { fetchUser, withCsrfRetry } from '@lib/user'
import type { GetServerSideProps, NextPage } from 'next'
import { useMutation } from 'react-query'
import { Routes } from '@lib/constants'
import Container from '@components/common/Container'
import ForgotPasswordForm from '@components/forms/ForgotPasswordForm'

type RequiredProps = {}

type OptionalProps = Partial<{}>

const PasswortVergessen: NextPage<RequiredProps & OptionalProps> = (props) => {
  return (
    <main className="flex min-h-screen flex-col items-center justify-start pt-h-header md:justify-center md:bg-gray-50">
      <div className="w-full pt-25 md:pt-0">
        <Container>
          <div className="mx-auto w-full max-w-2xl space-y-5 bg-white px-4 md:px-35 md:pt-14 md:pb-25">
            <h1 className="font-serif text-5xl text-red-500">Passwort vergessen</h1>

            <ForgotPasswordForm />
          </div>
        </Container>
      </div>
    </main>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const queryClient = createNewQueryClient()

  if (await fetchUser(context.req).catch(() => false)) {
    return {
      redirect: {
        permanent: false,
        destination: Routes.Home,
      },
    }
  }

  return {
    props: {},
  }
}

export default PasswortVergessen
